export default __webpack_public_path__ + "static/media/header_mobile_m.5856b4b5.png";